import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { yorumOnayla, yorumReddet } from "../../features/admin3/admin3Slice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        cursor: pointer;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          width: 20%;
        }
      }
    }
  }
  .btn{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    p{
        color: var(--color-main);
        border: 1px solid var(--color-main);
        padding: 6px 10px;
        border-radius: 8px;
    }
  }
`;

const YorumOnaylariContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data.shipment?.soforAdi || "-"}</div>
            <div className="col">{data.comment || "-"}</div>
            <div className="col">{data.shipment.driverPhoneNumber || "-"}</div>
            <div className="col">{data.shipment.driverName || "-"}</div>
            <div className="col btn">
                <p 
                    onClick={() =>
                        dispatch(
                        yorumOnayla({
                            shipmentId: data.shipmentId,
                            truckerId: data.truckerId,
                        })
                    )
                }>Onayla</p>
                <p onClick={() =>
                    dispatch(
                        yorumReddet({
                            shipmentId: data.shipmentId,
                            truckerId: data.truckerId,
                        })
                    )
                }>Reddet</p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default YorumOnaylariContainer;
